const createModal = (payload) => {
  return {
    type: "createModal",
    payload,
  };
};
export default createModal;
